import * as Yup from "yup";

export const assetsFilterValidationSchema = Yup.object().shape({
  name: Yup.string().nullable(),
  category_id: Yup.number().nullable(),
  available: Yup.boolean().nullable(),
});
